import { jsPDF } from "jspdf";
import { usePdfHTML } from "./usePdfHTML";

export const generatePdf = async (data) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
    compressPdf: true,
  });

  doc.setProperties({
      title: "Ruoff Mortgage",
      subject: "Your Ruoff Mortgage Calculator Estimate",
      author: "Ruoff Mortgage",
      keywords: "Ruoff Mortgage",
      creator: "Ruoff Mortgage",
  });

  const el = await usePdfHTML(data);
  let pdfString = null;

  await doc.html(el, {
    callback: function (doc) {
        const pdfBytes = doc.output("datauristring");
        pdfString = pdfBytes;
    },
    x: 0,
    y: 0,
    width: 450,
    windowWidth: 1920,
  });

  return pdfString
}